import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { CivilForm } from './CivilForm';
import Notification, { notify } from '../../common/Notification/Notification';

storiesOf('Fillings/LocalCourtSearch/Forms/Civil & Criminal', module)
  .add('View', () => (
    <CivilForm
      onSubmit={action('searchDistrict')}
      onClickSearchReset={action('resetLocalSearch')}
    />
  ))
  .add('Search error', () => (
    <div>
      <Notification/>
      <CivilForm
        onSubmit={(...args) => {
          notify.error('Failed to search District Local Court');
          action('searchAppellate')(...args);
        }}
        onClickSearchReset={action('resetLocalSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/CivilForm.stories.jsx